import * as core from './appconfig-core';
console.log("imported core config:", core);
import * as site from './appconfig-site';
console.log("imported site config:", site);
export const config = {
  ...core.config,
  ...site.config,
};
console.log("merged:", config);
export default config;
